import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useOverdueTasks = () => {
  return useQuery({
    queryKey: ['overdue-tasks'],
    queryFn: async (): Promise<number> => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('User not authenticated');

      const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      
      const { data, error } = await supabase
        .from('tasks')
        .select('id, user_id, assigned_to')
        .lt('due_date', today)
        .not('status', 'in', '(done,cancelled)');

      if (error) {
        console.error('Error fetching overdue tasks:', error);
        return 0;
      }

      // Filter to include only tasks where user is creator, assignee, or linked
      let filteredData = data || [];

      // Get tasks where user is linked via task_users table
      const { data: linkedTasks, error: linkedError } = await supabase
        .from('task_users')
        .select('task_id')
        .eq('user_id', user.id);
      
      if (linkedError)
        console.warn('Error fetching linked tasks:', linkedError);
      
      const linkedTaskIds = new Set<string>((linkedTasks || []).map(t => t.task_id));
      
      // Filter: include tasks where created OR assigned OR linked
      filteredData = filteredData.filter(task => {
        const isCreator = task.user_id === user.id;
        const isAssigned = task.assigned_to === user.id;
        const isLinked = linkedTaskIds.has(task.id);
        return isCreator || isAssigned || isLinked;
      });

      return filteredData.length;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
  });
};
